import {
  hydrateRenderedComponents,
  RenderServiceDOM
} from "@streeteasy/render-service/client";

import {
  HdpForm,
  MobileFormButtonHdp
} from "src/features/contact-boxes/components/ExpertsHDPContactBox";
import { HomeClaimContent } from "src/features/home-claim";
import {
  ContactSellersAgentCTA,
  ListingAgentContactDrawer
} from "src/features/listing-agent-contact";
import {
  ConnectWithAgentCTA,
  ExpertsMatchDrawer
} from "src/features/listing-agent-match-on-hdp";
import ListingDescriptionWidget from "src/features/listing-description-widget";
import { MobileSearchAction } from "src/features/mobile-search-action";
import HDPOpenHousesApp from "src/features/open-house-registration-hdp";
import SellerDashboardEntrypoint from "src/features/seller-dashboard/components/SellerDashboardEntrypoint/SellerDashboardEntrypoint";
import {
  AgentToolsActions,
  ScheduleShowingButton
} from "src/features/showing-time";
import { apolloWrapper } from "src/shared/contact-boxes/experts/utilities/cache";
import exportComponentsToRails from "src/shared/utilities/exportComponentsToRails";

global.RenderServiceDOM = RenderServiceDOM;

exportComponentsToRails("hdp", {
  expertMatchDrawer: ExpertsMatchDrawer,
  listingAgentContactDrawer: ListingAgentContactDrawer,
  homeClaimModal: import("src/features/home-claim/components/HomeClaimModal"),
  rentalPricesAndTerms: import(
    "src/features/rental-price-transparency/components/RentalPricesAndTerms"
  ),
  SellerInquiry: import("src/features/home-claim/components/SellerInquiry"),
  expertsForm: apolloWrapper(HdpForm),
  mobileExpertsForm: apolloWrapper(MobileFormButtonHdp),
  hideUnhideListing: import("src/features/hide-listings"),
  sellerDashboardEntrypoint: SellerDashboardEntrypoint
});

hydrateRenderedComponents("hdp", {
  AgentToolsActions,
  connectWithAgentCTA: ConnectWithAgentCTA,
  contactSellersAgentCTA: ContactSellersAgentCTA,
  homeClaimContent: HomeClaimContent,
  listingNotes: import("src/features/listing-notes"),
  mobileSearchAction: MobileSearchAction,
  ListingDescriptionWidget,
  hdpOpenHouses: HDPOpenHousesApp,
  scheduleShowingButton: ScheduleShowingButton,
  sellerDashboardEntrypoint: SellerDashboardEntrypoint
});
